import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import ReactEcharts from "echarts-for-react";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const Contributions = ({ graphValues, loader }) => {

  const [options, setOptions] = useState({});
  useEffect(() => {
    if (Object.keys(graphValues).length > 0) {
      setOptions({
        // height:"100px",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: "18px"
          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: graphValues.xAxis,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          maxInterval: 1
        },
        series: [
          // {
          //   name: 'Total Bookings',
          //   data: [35, 59, 80, 81, 56, 55, 40,28, 48, 40, 19, 86, 27],
          //   type: 'bar',
          //   stack: 'x',
          //   itemStyle: {color: '#0062FF'}
          // },
          // {
          //   name:'Tickets',
          //   data: [28, 48, 40, 19, 86, 27, 90,35, 59, 80, 81, 56, 55],
          //   type: 'bar',
          //   stack: 'x',
          //   itemStyle: {color: '#57B8FF'}
          // },
          {
            name: "Agent Bookings",
            data: graphValues.values,
            type: "bar",
            // stack: 'x',
            itemStyle: { color: "#0062FF" },
          },
        ],
      });
    }
  }, [graphValues]);
  return (
    <Card>
      <CardBody className="chart-block">
        <div className="d-con-header">Your Contributions</div>
        {loader ? <Skeleton width={"100%"} height={"90%"}/> : <ReactEcharts option={options} style={{ height: "90%" }} />}
      </CardBody>
    </Card>
  );
};

export default Contributions;
